export const FEED_ITEM_TYPES = [
  {
    type: 'most-popular-match-preview',
    label: 'widgets.betOfTheDay.label',
    pushLabel: 'widgets.betOfTheDay.push.label',
    pushDescription: 'widgets.betOfTheDay.push.description',
    icon: 'today',
    color: 'primary',
  },
  {
    type: 'bet-of-the-day',
    label: 'widgets.bestCommunityTip.label',
    pushLabel: 'widgets.bestCommunityTip.push.label',
    pushDescription: 'widgets.bestCommunityTip.push.description',
    icon: 'people',
    color: 'cyan',
  },
  {
    type: 'accumulator-of-the-day',
    label: 'widgets.accaOfTheDay.label',
    pushLabel: 'widgets.accaOfTheDay.push.label',
    pushDescription: 'widgets.accaOfTheDay.push.description',
    icon: 'trophy',
    color: 'accent',
  },
  {
    type: 'most-dropping-odd',
    label: 'widgets.droppingOdds.label',
    pushLabel: 'widgets.droppingOdds.push.label',
    pushDescription: 'widgets.droppingOdds.push.description',
    icon: 'trendingDown',
    color: 'warning',
  },
  {
    type: 'live-fixture-first-goal',
    label: 'widgets.liveValueBetAlert.label',
    pushLabel: 'widgets.liveValueBetAlert.push.label',
    pushDescription: 'widgets.liveValueBetAlert.push.description',
    icon: 'flash',
    color: 'danger',
  },
  {
    type: 'live-expert-tip',
    label: 'widgets.liveExpertTip.label',
    pushLabel: 'widgets.liveExpertTip.push.label',
    pushDescription: 'widgets.liveExpertTip.push.description',
    icon: 'ribbon',
    color: 'yellow',
  },
  {
    type: 'trend-of-the-day',
    label: 'widgets.trendOfTheDay.label',
    pushLabel: 'widgets.trendOfTheDay.push.label',
    pushDescription: 'widgets.trendOfTheDay.push.description',
    icon: 'trendingUp',
    color: 'teal',
  },
  {
    type: 'trending-tipster',
    label: 'widgets.trendingTipster.label',
    pushLabel: 'widgets.trendingTipster.push.label',
    pushDescription: 'widgets.trendingTipster.push.description',
    icon: 'personCircle',
    color: 'purple',
  },
  {
    type: 'matched-trends',
    label: 'widgets.statsAlert.label',
    pushLabel: 'widgets.statsAlert.push.label',
    pushDescription: 'widgets.statsAlert.push.description',
    icon: 'statsChart',
    color: 'violet',
  },
  {
    type: 'daily-banker',
    label: 'widgets.dailyBanker.label',
    pushLabel: 'widgets.dailyBanker.push.label',
    pushDescription: 'widgets.dailyBanker.push.description',
    icon: 'cash',
    color: 'gold',
  },
  {
    type: 'daily-value-bet',
    label: 'widgets.dailyValueBet.label',
    pushLabel: 'widgets.dailyValueBet.push.label',
    pushDescription: 'widgets.dailyValueBet.push.description',
    icon: 'diamond',
    color: 'primary',
  },
];

export const EMAIL_NOTIFICATION_TOPICS = [
  {
    type: 'accumulator-of-the-day',
    emailLabel: 'widgets.accaOfTheDay.email.label',
    emailDescription: 'widgets.accaOfTheDay.email.description',
  },
  {
    type: 'daily-betting-dose',
    emailLabel: 'widgets.dailyBettingDose.email.label',
    emailDescription: 'widgets.dailyBettingDose.email.description',
  },
];
